module.exports = __webpack_public_path__ + "img/uid-guide-img-2.ed4873a1.jpeg";